import { all } from "redux-saga/effects"

import { oidcWatcherSaga } from "@modules/oidc/src"
import { dataWatcherSaga } from "@redux/common/scopedObject/sagas"
import { actionRequestWatcherSaga } from "@redux/usecases/actionRequests/saga"
import { challengesWatcherSaga } from "@redux/usecases/challengesForManagement"
import { classifyProjectWatcherSaga } from "@redux/usecases/classifyProject"
import { documentWatcherSaga } from "@redux/usecases/documents/sagas"
import { lockOrUnlockWatcherSaga } from "@redux/usecases/lock/saga"
import { onboardingWatcherSaga } from "@redux/usecases/onboarding/sagas"
import { projectStateWatcherSaga } from "@redux/usecases/projectState"
import { proposalAttachmentWatcherSaga } from "@redux/usecases/proposalAttachments/saga"
import { reportEntityWatcherSaga } from "@redux/usecases/report/saga"
import { statisticsWatcherSaga } from "@redux/usecases/statistics/sagas"
import { transitionWatcherSaga } from "@redux/usecases/transitions/saga"
import { userAccountWatcherSaga } from "@redux/usecases/userAccount/sagas"
import { userObjectRolesWatcherSaga } from "@redux/usecases/userObjectRoles/saga"

import { authWatcherSaga } from "./auth"
import { currentUserWatcherSaga } from "./currentUser"
import { feedbackWatcherSaga } from "./feedback"
import { ideaWatcherSaga } from "./idea"
import { myProjectsWatcherSaga } from "./myProjects"
import { platformWatcherSaga } from "./platform"
import { programWatcherSaga } from "./program"
import { projectWatcherSaga } from "./project"
import { registrationWatcherSaga } from "./registration"
// import { teamUploadsWatcherSaga } from "./teamUploads"
import { usersWatcherSaga } from "./users"
import { verificationWatcherSaga } from "./verification"

// ALL sagas must be registered here!

export function* rootSaga(): any {
  yield all([
    classifyProjectWatcherSaga(),
    actionRequestWatcherSaga(),
    authWatcherSaga(),
    currentUserWatcherSaga(),
    documentWatcherSaga(),
    challengesWatcherSaga(),
    feedbackWatcherSaga(),
    dataWatcherSaga(),
    myProjectsWatcherSaga(),
    ideaWatcherSaga(),
    lockOrUnlockWatcherSaga(),
    projectWatcherSaga(),
    onboardingWatcherSaga(),
    platformWatcherSaga(),
    projectStateWatcherSaga(),
    programWatcherSaga(),
    reportEntityWatcherSaga(),
    registrationWatcherSaga(),
    statisticsWatcherSaga(),
    // teamUploadsWatcherSaga(),
    proposalAttachmentWatcherSaga(),
    transitionWatcherSaga(),
    userAccountWatcherSaga(),
    userObjectRolesWatcherSaga(),
    usersWatcherSaga(),
    verificationWatcherSaga(),
    oidcWatcherSaga(),
  ])
}

